import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "notificaciones",
    "emailsbysends",
    "EmailForm",
    "/notificaciones",
);

export default handleActions(reducers, initialState);
